export const radius = {
  xs: "6px",
  sm: "8px",
  md: "10px",
  lg: "12px",
  xl: "16px",
  "2xl": "20px",
  "3xl": "24px",
  "4xl": "32px",
  "5xl": "40px"
} as const;

export type Radius = typeof radius;
